// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:1099px){.ProductBlocks{margin:20px}}.ProductBlocks .container{max-width:1476px}", ""]);
// Exports
module.exports = exports;
